import axiosInstance from './axios';

export interface Expense {
    id: string;
    concepto: string;
    categoria: string;
    monto: number;
    fecha: string;
    fechaPago?: string;
    metodoPago?: string;
    status: string;
    proveedor?: string;
    numeroFactura?: string;
    observaciones?: string;
    archivoUrl?: string;
    archivoNombre?: string;
    companyId: string;
    createdAt: string;
    updatedAt: string;
}

export interface CreateExpenseDto {
    concepto: string;
    categoria: string;
    monto: number;
    fecha?: string;
    proveedor?: string;
    numeroFactura?: string;
    observaciones?: string;
    shiftId?: string;
    metodoPago?: string;
    status?: string;
}

export interface UpdateExpenseDto {
    concepto?: string;
    categoria?: string;
    monto?: number;
    fecha?: string;
    fechaPago?: string;
    metodoPago?: string;
    status?: string;
    proveedor?: string;
    numeroFactura?: string;
    observaciones?: string;
}

export interface ExpenseFilters {
    categoria?: string;
    status?: string;
    fechaInicio?: string;
    fechaFin?: string;
    search?: string;
}

export interface ExpenseStats {
    totalGastado: number;
    totalPendiente: number;
    totalPagado: number;
    cantidadPendientes: number;
    cantidadPagados: number;
    mesActual: {
        total: number;
        cantidad: number;
    };
    porCategoria: Array<{
        categoria: string;
        total: number;
        cantidad: number;
    }>;
}

/**
 * Crear un nuevo gasto
 */
export const createExpense = async (data: CreateExpenseDto): Promise<Expense> => {
    const response = await axiosInstance.post('/expenses', data);
    return response.data;
};

/**
 * Obtener lista de gastos con filtros
 */
export const getExpenses = async (filters?: ExpenseFilters): Promise<Expense[]> => {
    const response = await axiosInstance.get('/expenses', { params: filters });
    return response.data;
};

/**
 * Obtener un gasto por ID
 */
export const getExpenseById = async (id: string): Promise<Expense> => {
    const response = await axiosInstance.get(`/expenses/${id}`);
    return response.data;
};

/**
 * Actualizar un gasto
 */
export const updateExpense = async (id: string, data: UpdateExpenseDto): Promise<Expense> => {
    const response = await axiosInstance.put(`/expenses/${id}`, data);
    return response.data;
};

/**
 * Eliminar un gasto
 */
export const deleteExpense = async (id: string): Promise<void> => {
    await axiosInstance.delete(`/expenses/${id}`);
};

/**
 * Obtener estadísticas de gastos
 */
export const getExpenseStats = async (): Promise<ExpenseStats> => {
    const response = await axiosInstance.get('/expenses/stats');
    return response.data;
};
